import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

const FOCUS_DELAY = 300;

@Directive({
  selector: '[idealsAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  readonly #elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.#elementRef.nativeElement.focus();
    }, FOCUS_DELAY);
  }
}
